module.exports = __webpack_public_path__ + "img/2.1d50c19a.svg";